/**
 * IFIP Global Excellence Portal - Language Manifest
 * Architecture: AI-Driven Translation Registry
 * Note: Data is now hydrated dynamically via translationService.js
 */
export const languageManifest = {
  en: { label: "English", nativeName: "English", dir: "ltr",},
  es: { label: "Spanish", nativeName: "Español", dir: "ltr",},
  zh: { label: "Mandarin", nativeName: "简体中文", dir: "ltr",},
  ja: { label: "Japanese", nativeName: "日本語", dir: "ltr",},
  tl: { label: "Filipino", nativeName: "Filipino", dir: "ltr",},
  ms: { label: "Malay", nativeName: "Bahasa Melayu", dir: "ltr",},
  ar: { label: "Arabic", nativeName: "العربية", dir: "rtl",},
  fr: { label: "French", nativeName: "Français", dir: "ltr",},
  nl: { label: "Netherlands", nativeName: "Nederlands", dir: "ltr",},
  de: { label: "German", nativeName: "Deutsch", dir: "ltr",},
  ru: { label: "Russian", nativeName: "Русский", dir: "ltr",},
  pt: { label: "Portuguese", nativeName: "Português", dir: "ltr",},
  it: { label: "Italian", nativeName: "Italiano", dir: "ltr",},
  ko: { label: "Korean", nativeName: "한국어", dir: "ltr",},
  hi: { label: "Hindi", nativeName: "हिन्दी", dir: "ltr",},
  ur: { label: "Urdu", nativeName: "اردو", dir: "rtl",}
};

export {
  countryEndonyms,
  WORLD_BANK_TIERS,
  normalizeCountryKey,
  countryEnglishLabel,
  LEGACY_COUNTRY_ALIASES,
  BILLABLE_LEVELS,
} from './countries';

export const defaultLanguage = "en";
